import * as React from 'react';
import {Route, Switch} from 'react-router-dom';
import Ingreso from './pages/ingreso/ingreso';
import Portada from './pages/portada/portada';
import MainWrapper from '../theme/app/MainWrapper';
import Layout from './common/layout/layout';
import Rechazos from './pages/rechazos/rechazos';
import Stock from './pages/stock/stock';
import StockProducto from './pages/stock/producto/stock-producto';
import Coberturas from './pages/coberturas/coberturas';
import Tdos from './pages/tdos/tdos';
import Prioritarios from './pages/prioritarios/prioritarios';
import PrioritariosConf from './pages/prioritarios/configuracion/prioritarios-conf';
import TiendaPagoConf from './pages/prioritarios/tiendapago/tienda-pago-conf';
import VisicoolerCliente from './pages/visicooler/clientes/visicooler-cliente';
import VisicoolerModelo from './pages/visicooler/modelos/visicooler-modelo';
import VisicoolerNuevo from './pages/visicooler/nuevo/visicooler-nuevo';
import VisicoolerCuotas from './pages/visicooler/cuotas/visicooler-cuotas';
import AvanceAnual from './pages/avance/anual/avance-anual';
import CelularesZonasCarga from './pages/celulares/zonas/carga/celulares-zonas-carga';
import CelularesZonas from './pages/celulares/zonas/celulares-zonas';
import CelularesPdvs from './pages/celulares/zonas/celulares-pdvs';
import {FuerzasVenta} from '../utils/constants';

const Router = () => (
    <MainWrapper>
        <main>
            <Switch>
                <Route exact={true} path='/' component={Ingreso}/>
                <Route path='/ingreso' component={Ingreso}/>
                <Route path='/' component={wrappedRoutes}/>
            </Switch>
        </main>
    </MainWrapper>
);

const wrappedRoutes = () => (
    <div>
        <Layout/>
        <div className='container__wrap'>
            <Route path='/portada' component={Portada}/>
            <Route path='/avances/anual' component={AvanceAnual}/>
            <Route path='/rechazos' component={Rechazos}/>
            <Route path='/stock/gloria' component={Stock}/>
            <Route path='/stock/producto' component={StockProducto}/>
            <Route path='/coberturas' component={Coberturas}/>
            <Route path='/t2' component={Tdos}/>
            <Route path='/prioritarios/gloria'
                   component={(props) => <Prioritarios fuerzaVenta={FuerzasVenta.GLORIA_NORTE} {...props}/>}/>
            <Route path='/prioritarios/sanfernando'
                   component={(props) => <Prioritarios fuerzaVenta={FuerzasVenta.SAN_FERNANDO} {...props}/>}/>
            <Route path='/prioritarios/kimberly'
                   component={(props) => <Prioritarios fuerzaVenta={FuerzasVenta.KIMBERLY} {...props}/>}/>
            <Route path='/prioritarios/nexo'
                   component={(props) => <Prioritarios fuerzaVenta={FuerzasVenta.NEXO} {...props}/>}/>
            <Route path='/prioritarios/stanley'
                   component={(props) => <Prioritarios fuerzaVenta={FuerzasVenta.STANLEY} {...props}/>}/>
            <Route path='/prioritarios/auren2'
                   component={(props) => <Prioritarios fuerzaVenta={FuerzasVenta.AUREN2} {...props}/>}/>
            <Route path='/prioritarios/configuracion' component={PrioritariosConf}/>
            <Route path='/prioritarios/tiendapago' component={TiendaPagoConf}/>
            <Route path='/visicoolers/:fuerzaVenta/asignados' component={VisicoolerCliente} exact={true}/>
            <Route path='/visicoolers/:fuerzaVenta/modelos' component={VisicoolerModelo} exact={true}/>
            <Route path='/visicoolers/:fuerzaVenta/asignar' component={VisicoolerNuevo} exact={true}/>
            <Route path='/visicoolers/:fuerzaVenta/cuotas' component={VisicoolerCuotas} exact={true}/>
            <Route path='/celulares/zonales/data' component={CelularesZonasCarga} exact={true}/>
            <Route path='/celulares/zonales' component={CelularesZonas} exact={true}/>
            <Route path='/celulares/pdvs' component={CelularesPdvs} exact={true}/>
        </div>
    </div>
);

export default Router;



// WEBPACK FOOTER //
// ./src/components/router.tsx